// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".components-pages-brands-page-brands-id-type-1styleMobileGrid-container-jjjzl{margin:0 auto;padding:0 12px;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "components-pages-brands-page-brands-id-type-1styleMobileGrid-container-jjjzl"
};
module.exports = ___CSS_LOADER_EXPORT___;
